import { create } from 'zustand';

export type CalendarStore = {
  startDate: Date | null;
  setStartDate: (d: Date | null) => void;
  jobId: number | null;
  setJobId: (id: number | null) => void;
  resetStartDate: () => void;
  resetJobId: () => void;
};

export const useCalendarStore = create<CalendarStore>((set) => ({
  startDate: null,
  setStartDate: (d: Date | null) => set({ startDate: d }),
  jobId: null,
  setJobId: (id: number | null) => set({ jobId: id }),
  resetStartDate: () => set({ startDate: null }),
  resetJobId: () => set({ jobId: null })
}));
